import { ComponentPublicInstance } from "vue";
import initValue from "./initValue";
import Core from "@tmagic/core";

type ConfigProps = typeof initValue;

const install = (config: ConfigProps) => {
  const miniServiceSdkUrl =
    window.mlEnv === "production"
      ? config.env === 1
        ? "//mnweb.mini1.cn/activity/miniwtool/@service/activity-sdk@1.0.1.js"
        : "//mnweb.mini1.cn/activity/miniwtool/@service/activity-ovs-sdk@1.0.1.js"
      : "//mnweb.mini1.cn/activity/miniwtool/@service/activity-sdk@1.0.1-test.js";
  const registerMiniService = window.asyncLoadScript(miniServiceSdkUrl);
  (window as any).onReadyMiniService = () => {
    return registerMiniService.then(() => {
      if ((window as any).MiniService) {
        return (window as any).MiniService;
      }
      return Promise.reject("MiniService is not ready");
    });
  };

  return {
    appCreated: (app: Core) => {},
    appMounted: (app: Core) => {},
    pageChange: (app: Core) => {},
    componentSetup: (
      app: Core,
      vm: ComponentPublicInstance,
      componentConfig: any
    ) => {},
  };
};

export default install;
